export class Home {
    SearchText: string;
    ThisYear: boolean;
    ThisMonth:boolean;
}
